import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CommunityView } from './community-view/CommunityView';
import { recordCommunityVisit } from './recentCommunities';

export function CommunityPage() {
  const { communityId = '' } = useParams();

  // Feed the My Communities "Jump Back In" rail with view history.
  useEffect(() => {
    recordCommunityVisit(communityId);
  }, [communityId]);

  return <CommunityView communityId={communityId} />;
}
